import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Loading = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M22.6667 6.33333C22.6667 5.04467 23.7113 4 25 4C36.598 4 46 13.402 46 25C46 36.598 36.598 46 25 46C13.402 46 4 36.598 4 25C4 23.7113 5.04467 22.6667 6.33333 22.6667C7.622 22.6667 8.66667 23.7113 8.66667 25C8.66667 34.0207 15.9793 41.3333 25 41.3333C34.0207 41.3333 41.3333 34.0207 41.3333 25C41.3333 15.9793 34.0207 8.66667 25 8.66667C23.7113 8.66667 22.6667 7.622 22.6667 6.33333Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  )
}
